import { basePageViewData } from '../utils';

const errorPageView = ({ trackPageView, getContext }) => {
  const { TRACK_ERROR_PAGE_RENDERED } = require('../../actions/pagesRendered');

  const errorPageLoaded = trackPageView((action, _prevState, nextState) => {
    const context = getContext();
    const { cookies } = context;

    return {
      category: 'Error Page',
      name: 'Error Page',
      properties: {
        ...basePageViewData(nextState, { cookies }),
      },
    };
  });

  return {
    [TRACK_ERROR_PAGE_RENDERED]: errorPageLoaded,
  };
};

export default errorPageView;
